/**
 * Leasing Proposals — boundary contract schemas.
 *
 * Owned here, not beside the route: `apps/api/src/routes/manager/leasing-proposals.schemas.ts`
 * imports and re-exports this to register the routes, and
 * `apps/landlord/src/lib/leasing.api.ts` derives its `AppointmentProposal` type from the
 * same object. See packages/api-types/README.md.
 *
 * Covers every route returning a proposal (as `proposal`, or within `proposals`):
 *   GET  /landlord/api/leads/:id/proposals
 *   POST /landlord/api/leads/:id/proposals/:proposalId/confirm
 *   POST /landlord/api/leads/:id/proposals/:proposalId/reject
 */
import { z } from 'zod';
const cuid = z.string(); // cuid2 — NOT uuid
const dateString = z.string(); // ISO 8601 string
// Proposal status enum — mirrored as a plain Zod enum (not cross-imported from the
// route-local module, which keeps its own copy since it's used only there).
const ProposalStatusSchema = z.enum(['pending', 'confirmed', 'rejected', 'cancelled', 'superseded']);
// ---------------------------------------------------------------------------
// Proposal response
// ---------------------------------------------------------------------------
export const ProposalResultSchema = z.object({
    id: cuid,
    leadId: cuid,
    listingId: cuid,
    proposedFor: dateString,
    durationMinutes: z.number().int().positive(),
    proposedNotes: z.string().nullable(),
    status: ProposalStatusSchema,
    showingAppointmentId: cuid.nullable(),
    responseNotes: z.string().nullable(),
    proposedByActorType: z.string(),
    respondedByUserId: cuid.nullable(),
    respondedAt: dateString.nullable(),
    createdAt: dateString,
    updatedAt: dateString,
});
//# sourceMappingURL=proposals.js.map